'use client'

import { memo } from 'react'
import { ProductDownloadSection } from '@/app/ninxl/_components/product-download-section'

const NINXL_DOWNLOAD_API = '/api/ninxl/download'

/** baby: Download card only: parent CraftSection owns #download for nav. */
export const CraftDownload = memo(function CraftDownload() {
  return (
    <div className="mx-auto max-w-xl text-center">
      <p className="craft-section__eyebrow">Install</p>
      <h2 className="craft-section__title" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        Put NINX on your machine
      </h2>
      <p className="craft-section__body" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        Download the desktop app, warm a local model, and start privately. Cloud plugins stay
        opt-in.
      </p>

      <div className="craft-download__card">
        <ProductDownloadSection
          productLabel="NINX desktop"
          productDescription="Private on-device AI for Mac and Windows."
          apiBase={NINXL_DOWNLOAD_API}
          queryKey={['ninxl-craft-v2-download']}
          recommended
          variant="primary"
          layout="inline"
        />
      </div>
    </div>
  )
})

CraftDownload.displayName = 'CraftDownload'
